// src/components/AdminLayout.js
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import TopHeader from './TopHeader';
import Sidebar from './Sidebar';

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);
  
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      
      {/* 1. Top Header (Takes 100% width at the top) */}
      <div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 50 }}>
        <TopHeader toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
      </div>

      {/* 2. Body container (Starts below the 72px header) */}
      <div style={{ display: 'flex', marginTop: '72px', flex: 1 }}>
        
        {/* Sidebar Component */}
        <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />

        {/* Dynamic Content Area */}
        <main className="dashboard-content">
          <Outlet /> 
        </main>

      </div>
    </div>
  );
};

export default AdminLayout;